import { Component, ElementRef, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DistributionPreprojectFileComponent } from '../distribution-preproject-file/distribution-preproject-file.component';
import { MainService } from 'src/app/services/main.service';
import { CampaignsService } from 'src/app/services/campaigns.service';
import Swal from 'sweetalert2';
import { DistributionArtFileComponent } from '../distribution-art-file/distribution-art-file.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DistributionPreprojectKitComponent } from '../distribution-preproject-kit/distribution-preproject-kit.component';
import * as pdfjsLib from 'pdfjs-dist';
import { SkuImageComponent } from '../sku-image/sku-image.component';
import { DistributionArtPreviewComponent } from '../distribution-art-preview/distribution-art-preview.component';
import { LayoutViewComponent } from '../layout-view/layout-view.component';

@Component({
  selector: 'app-distribution-preproject',
  templateUrl: './distribution-preproject.component.html',
  styleUrls: ['./distribution-preproject.component.scss']
})
export class DistributionPreprojectComponent implements OnInit {
  
  strategy: any;
  campaign: any;
  odtFiles: any;
  isClientUsr: boolean = false;
  isLoading = true;
  canUploadOdt: boolean = false;
  materiales: { id: number, nombre: string, cantidad: number }[] = [];
  materialesAnteriores: { id_material: number, cantidad: number }[] = [];
  dataMatCamp: { id_material: number}[] = [];

  versionDesde: number | null = 1;

  artes: { 
    nombre_archivo: string, 
    archivo: string, 
    sku: string, 
    id_sku: number,
    bitValido: number, 
    blob: string,
    nombre_op: string,
    accesorio1: string,
    mult_accesorio1: string,
    accesorio2: string,
    mult_accesorio2: string,
    idArtePreproyecto: number,
    medida_x: number,
    medida_y: number,
    file_respuesta: string, 
    file_respuesta_report: string, 
    nombre_file: string, 
    nombre_file_report: string, 
    fileUrl: SafeResourceUrl, 
    fileUrlReport: SafeResourceUrl,
    fileUrlArte: SafeResourceUrl,
    nombre_layout: string,
    layout: string,
    fyv: string,
    material_id: number,
    bitEnviaAccesorios: number,
    hasChanged: boolean,
    skusPlantas: Array<{ id: number; sku: string; planta: string }>,
    kit_mats: string,
    id_archivo: number, 
    nombre_ftp: string, 
    labelProcesando: string,
    skuOdoo: Array<{ product_id: number; buho_sku: string; descripcion: string; tintas: string; family:string; family_id:number; accessories: Array<{product_name: string;}>;}>,
    type_match: number,
    paginas: number,
    page_index: number,
    id_family: number,
    ancho: number,
    alto: number,
    f_igual_v: boolean,
    pagesMedidasDif: number,
    archivo_respuesta_report: string
  }[] = [];

  allMatches: { 
    nombre_op: string,
    nombre_layout: string,
    layout: string,
    cantidad: number,
    id_archivo: number,
    idArtePreproyecto: number,
    id_sku: number,
    material_id: number,
    bitValido: number,
    archivo_respuesta_report: string,
  }[] = [];
  materialSelectionCounts = new Map<string, number>();

  matches: { 
    nombre_op: string,
    nombre_layout: string,
    layout: string,
    cantidad: number,
    id_archivo: number,
    idArtePreproyecto: number,
    id_sku: number,
    material_id: number
  }[] = [];

  objSend = {};
  objSendPreproyecto = {};
  flagArtesPreproyecto = true;

  dataPreproject: {
    nombre_largo: string,
    folio: string,
    name_campana: string,
    area_responsable: string,
    fecha_inicio: Date | null,
    fecha_fin: Date | null,
    observaciones: string,
    id_preproyecto: number,
    archivo_layout: string,
    archivo_odt: string,
    status: string,    
    descripcion: string
  } = {
    nombre_largo: '',
    folio: '',
    name_campana: '',
    area_responsable: '',
    fecha_inicio: null,
    fecha_fin: null,
    observaciones: '',   
    id_preproyecto: 0,
    archivo_layout: '',
    archivo_odt: '',
    status: '',
    descripcion: ''
  };

  skusOdoo: any;
  archivos: any = [];
  originalData: any = [];
  mostrarAccesorios: boolean[] = [];
  files_respuesta: number = 0;

  // Por esta:
documents: {
  id_archivo: number;
  nombre_archivo: string;
  family: string;
  paginas: number;
  type_match: number;
  matches: any[];
  archivo: string;
  id_sku: number;
  ancho: number;
  alto: number;
  id_family: number;
  f_igual_v?: boolean;
  mostrar_accesorios?: boolean;
  skuOdoo?: any[];
  page_index?: number | null;
  pagesMedidasDif?: number;
  [key: string]: any;
}[] = [];

  selectedDocument: any = null;
  skusFamily: { product_id: number , planta: string, descripcion: string, tintas: string}[] = [];
  selectedMatchType = 1;
  folder_camp: any;

  searchTerm: any = "";
  filteredMateriales: Array<any> = [];
  completed: boolean = false;
  review: boolean = false;

  // Control de cambios en la primera pantalla y persistencia de preproyecto
  initialDocumentsSnapshot: string = '';
  preprojectLoaded: boolean = false;

  @ViewChildren('searchInput2') searchInputs2!: QueryList<ElementRef<HTMLInputElement>>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private campaignService : CampaignsService,
    private main : MainService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<DistributionPreprojectComponent>,
    public sanitizer: DomSanitizer,
  ) { 
    this.strategy = this.data.strategy;

    this.review = this.data.strategy.status_buho == 2 ? true : false;
    this.completed = this.data.strategy.st_odt == 1 ? true : false;
    this.folder_camp = this.data.folder_camp;
    this.campaign = this.data.campaign;
    this.isClientUsr = campaignService.isClientUsr();
    this.canUploadOdt = !this.data.islocked && this.campaignService.hasPermissions("upl_odt", true, false);
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {

    this.main.ShowLoading();
    this.campaignService.getArtesPreproyecto(this.strategy.id, this.campaign.id).subscribe(
      async (result: any) => {

        this.materiales = result.dataMat;
        this.materiales.sort((a, b) => a.nombre.localeCompare(b.nombre));
        this.artes = result.data;
        this.materialesAnteriores = result.dataMatPast;
        this.filteredMateriales = this.materiales;
        this.dataMatCamp = result.dataMatCamp;

        this.allMatches = result.dataMatches || [];
        this.skusFamily = result.skuOdoo;

        this.documents = await Promise.all(
          this.artes.map(async (item) => {
            const matches = this.organizeMatches(
              this.allMatches.filter((e: any) => e.id_archivo == item.id_archivo)
            );

            matches.forEach((match: any) => {
              match.version = match.version ?? null;
              match.countedMaterialId = this.normalizeMaterialId(match.material_id);
              const selectedMaterial = this.materiales.find(
                (material: any) => material.id == match.material_id
              );
              const selectedSku = item.skuOdoo?.find(
                (sku: any) => sku.product_id == match.id_sku
              );

              match.cantidad = selectedMaterial?.cantidad || 0;
              match.selectedSku = selectedSku;
              match.validando = false;
              match.tintas = selectedSku?.tintas || '';

              if(this.materialesAnteriores.length > 0){
                const matAnterior = this.materialesAnteriores.find((matAnt: any) => match.material_id == matAnt.id_material);
                if(matAnterior){
                  match.cantidadAnterior = matAnterior.cantidad;
                }                  
              }

            });

            return {
              id_archivo: item.id_archivo,
              nombre_archivo: item.nombre_archivo,
              archivo: item.archivo,
              family: item.skuOdoo[0]?.family || '',
              type_match: item.type_match || 1,
              paginas: item.paginas,
              skuOdoo: item.skuOdoo,
              page_index: item.page_index || null,
              id_family: item.id_family,
              id_sku: item.id_sku,
              ancho: item.ancho,
              alto: item.alto,
              f_igual_v: !!item.f_igual_v,
              mostrar_accesorios: true, // Inicializado por defecto en true
              pagesMedidasDif: item.pagesMedidasDif,
              matches
            };
          })
        );

        this.documents.forEach(document => {
          this.normalizePageMatchRows(document);
          this.ensureInitialMatch(document);
        });
        this.updateMaterialSelectionCounts();
        this.selectedDocument = this.documents[0];

        // Guardamos la captura inicial limpia sin cambios
        this.initialDocumentsSnapshot = this.getDocumentsSnapshot();

        this.main.HideLoading();

      },
      (err: any) => {
        this.main.HideLoading();
        Swal.fire({
          icon: 'error',
          title: 'Error al obtener registros',
          text: 'Ocurrió un error al obtener los registros.'
        });
      }
    );
  }

  // Genera un snapshot serializado de los campos editables
  private getDocumentsSnapshot(): string {
    if (!this.documents) return '';
    return JSON.stringify(this.documents.map(d => ({
      id_archivo: d.id_archivo,
      type_match: d.type_match,
      f_igual_v: d.f_igual_v,
      mostrar_accesorios: d.mostrar_accesorios,
      matches: (d.matches || []).map((m: any) => ({
        material_id: m.material_id,
        nombre_layout: m.nombre_layout,
        layout: m.layout,
        id_sku: m.id_sku,
        mult_accesorio1: m.mult_accesorio1,
        mult_accesorio2: m.mult_accesorio2,
        version: m.version,
        page_index: m.page_index,
        is_child_row: m.is_child_row
      }))
    })));
  }

  // Comprueba si hubo alteraciones en los artes o matches
  hasChangesInArtes(): boolean {
    return this.initialDocumentsSnapshot !== this.getDocumentsSnapshot();
  }

  openDialogPreprojectFile() {
    this.matDialog.open(DistributionPreprojectFileComponent, {
      panelClass: ['dialogs-main'],
      data: {
        folder_camp: this.folder_camp,
        strategy : this.data.strategy
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.dialogRef.close({ reload: true });
        }
      }
    );
  }
  
  openPreview() {
    this.matDialog.open(DistributionArtPreviewComponent, {
      panelClass: ['dialogs-xl'],
      data: {
        strategy : this.data.strategy,
        artFiles: this.odtFiles,
        tipo: 2
      }
    }).afterClosed().subscribe(
      resp => {
        if (resp?.reload) {
          this.dialogRef.close({ reload: true });
        }
      }
    );
  }

  saveInfoArtes(data: any){
  
    this.objSend = {
      idStrategy: this.strategy.id,
      dataForm: data,
      documents: this.documents
    };

    this.campaignService.setArtesPreproyecto(this.objSend).subscribe(
      (result:any) => {
        // Al guardar exitosamente, actualizamos la captura base
        this.initialDocumentsSnapshot = this.getDocumentsSnapshot();
        Swal.fire({
          icon: 'success',
          title: 'Información de artes guardada'
        });
      },
      (err:any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar registros',
          text: 'Ocurrió un error al guardar los registros.'
        });
      }
    );
  }

  switchArtesPreproyecto(artes: any, formPreproject: any, type: number, matches: any) {
    this.flagArtesPreproyecto = !this.flagArtesPreproyecto;

    if (!this.flagArtesPreproyecto) {
      // Solo guardar si no está completada y si hubo cambios reales
      if (!this.completed && this.hasChangesInArtes()) {
        this.saveInfoArtes(matches);
      }

      // Solo consultar de BD la primera vez para no sobreescribir fechas u observaciones ya capturadas
      if (!this.preprojectLoaded) {
        this.getPreproyectoEstrategia();
      }
    }
  }

  savePreproyecto(data: any) {
    if (!data.fecha_inicio || !data.fecha_fin) {
      Swal.fire({
        icon: 'warning',
        title: 'Fechas requeridas',
        text: 'Debes seleccionar la fecha de inicio y la fecha de envío antes de generar el preproyecto.'
      });
      return;
    }

    if (data.id_preproyecto == undefined) { data.id_preproyecto = 0; }

    this.objSendPreproyecto = {
      idStrategy: this.strategy.id,
      dataForm: data
    };

    this.campaignService.setFormPreproyecto(this.objSendPreproyecto).subscribe(
      (result: any) => {
        this.dataPreproject.id_preproyecto = result.data;
        this.generarPreproyecto(this.dataPreproject.id_preproyecto);
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar registros',
          text: 'Ocurrió un error al guardar los registros.'
        });
      }
    );
  }

  getPreprojectGlobal(){

    this.campaignService.getPreprojectGlobal(this.data.campaign.id).subscribe(
      (result:any) => {         
        const fechaOriginal1 = result.data[0]?.fecha_inicio || null;
        const fechaOriginal2 = result.data[0]?.fecha_fin || null;
  
        if(fechaOriginal1 != null){
          const [year, month, day] = fechaOriginal1.split('-').map(Number);
          const fecha1 = new Date(year, month - 1, day);
          result.data[0].fecha_inicio = fecha1;
        }
        if(fechaOriginal2 != null){
          const [year2, month2, day2] = fechaOriginal2.split('-').map(Number);
          const fecha2 = new Date(year2, month2 - 1, day2);
          result.data[0].fecha_fin = fecha2;
        }

        if(result.data[0] != undefined){
          this.dataPreproject = result.data[0];
        }
  
      },
      (err:any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al obtener los registros.'
        });
      }    
    ); 

  }

  generarPreproyecto(id_preproyecto: number){

    Swal.fire({
      icon: 'info',
      title: 'Generando Preproyecto...',
      text: 'Por favor espera, no cierres ni recargues la página.',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.campaignService.generatePreproyecto(this.strategy.id,id_preproyecto).subscribe((result: any) => {
      this.estadoPreproyecto(id_preproyecto,result);
    });

  }

  estadoPreproyecto(id: number, resultt: any) {
    const interval = setInterval(() => {
      this.campaignService.getEstadoPreproyecto(id).subscribe((result: any) => {
        if (result[0][0].status === 'ok') {
          clearInterval(interval);
          this.getPreproyectoEstrategia();
          Swal.fire({ icon: 'success', title: 'Generación correcta' });
          this.data.strategy.bitPreproyecto = 0;
        } else if (result[0][0].status === 'error') {
          clearInterval(interval);
          this.getPreproyectoEstrategia();
          Swal.fire({
            icon: 'error',
            title: 'Error al generar preproyecto. ' + result[0][0].descripcion,
            text: 'Ocurrió un error en el proceso.'
          });
          console.error("Error al generar Preproyecto");
          console.log(result[0][0].descripcion);
        }
      });
    }, 15000);
  }

  getSourceURL(fileUrl: SafeResourceUrl): SafeResourceUrl {
    return fileUrl;
  }

  getPreproyectoEstrategia(){
    this.campaignService.getPreprojectEstrategia(this.strategy.id).subscribe(
      (result:any) => { 
        const fechaOriginal1 = result.data[0]?.fecha_inicio || null;
        const fechaOriginal2 = result.data[0]?.fecha_fin || null;

        if (fechaOriginal1 != null) {
          const [year, month, day] = fechaOriginal1.split('-').map(Number);
          const fecha1 = new Date(year, month - 1, day);
          result.data[0].fecha_inicio = fecha1;
        } else {
          if (result.data[0]?.fecha_inicio_global != null) {
            const [year, month, day] = result.data[0]?.fecha_inicio_global.split('-').map(Number);
            const fecha1 = new Date(year, month - 1, day);
            result.data[0].fecha_inicio = fecha1;
          }
        }

        if (fechaOriginal2 != null) {
          const [year2, month2, day2] = fechaOriginal2.split('-').map(Number);
          const fecha2 = new Date(year2, month2 - 1, day2);
          result.data[0].fecha_fin = fecha2;
        } else {
          if (result.data[0]?.fecha_fin_global != null) {
            const [year, month, day] = result.data[0]?.fecha_fin_global.split('-').map(Number);
            const fecha2 = new Date(year, month - 1, day);
            result.data[0].fecha_fin = fecha2;
          }
        }

        if (result.data[0] != undefined) {
          this.dataPreproject = result.data[0];
          this.preprojectLoaded = true;
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al obtener los registros.'
        });
      }    
    );
  }

  cargaVoBoCliente() {
    this.campaignService.setVoBoCliente(this.strategy.id).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Listo'
          });
          this.data.strategy.bitPreproyecto = 1;
          this.dialogRef.close();
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error en la operación.'
        });
      }
    );
  }

  checkChanges(arte: any) {
    const original = this.originalData.find((a: any) => a.idArtePreproyecto === arte.idArtePreproyecto);
    arte.hasChanged = original 
      ? (original.material_id !== arte.material_id || 
        original.nombre_layout !== arte.nombre_layout || 
        original.layout !== arte.layout || 
        original.fyv !== arte.fyv ||
        original.bitEnviaAccesorios !== arte.bitEnviaAccesorios ||
        original.kit_mats !== arte.kit_mats
      )
      : false;
  }

  onToggleChangeAcc(event: MatSlideToggleChange, index: number) {
    this.mostrarAccesorios[index] = event.checked;
  }

  getSkusOdoo() {
    this.campaignService.getSkus().subscribe(
      (result: any) => {
        this.skusOdoo = result.data2.sku_catalog;
        this.main.HideLoading();
      },
      (err: any) => {
        this.main.HideLoading();
        Swal.fire({
          icon: 'error',
          title: 'Error al obtener registros',
          text: 'Ocurrió un error al obtener los registros.'
        });
      }
    );
  }

  async onKitToggleChange(event: MatSlideToggleChange, arte: any) {
    if (event.checked) {
      this.main.ShowLoading();
      const paginas = await this.obtenerPaginas(arte.archivo);
      const dialogRef = this.matDialog.open(DistributionPreprojectKitComponent, {
        panelClass: ['dialogs-md'],
        data: {
          arte: arte,
          materiales: this.materiales,
          paginas: paginas
        }
      });
      this.main.HideLoading();

      dialogRef.afterClosed().subscribe(result => {
        arte.kit_mats = arte.kit_mats || null;
        arte.kit_mats = JSON.stringify(result);
        this.checkChanges(arte);
      });
    } else {
      arte.kit_mats = null;
      this.checkChanges(arte);
    }
  }

  async obtenerPaginas(url: string): Promise<number> {
    try {
      const pdf = await pdfjsLib.getDocument(url).promise;
      return pdf.numPages;
    } catch (error) {
      console.error('Error leyendo PDF', error);
      return 0;
    }
  }

  obtenerFilesFtp(nombre_arte: string, id_archivo: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let intentos = 0;
      const maxIntentos = 4;
      let intervalo: ReturnType<typeof setTimeout>;

      const consultarArchivo = () => {
        intentos++;
        this.campaignService.getFilesFtp(nombre_arte, id_archivo, 0).subscribe({
          next: (result: any) => {
            if (result.noEncontrado != 4) {
              clearTimeout(intervalo);
              resolve(result);
              return;
            }

            if (intentos >= maxIntentos) {
              resolve({
                mensaje: 'No se pudo obtener el archivo, intente más tarde',
                noEncontrado: 4
              });
              return;
            }

            intervalo = setTimeout(consultarArchivo, 15000);
          },
          error: (err: any) => {
            clearTimeout(intervalo);
            reject(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Ocurrió un error al consultar el reporte.'
            });
          }
        });
      };

      consultarArchivo();
    });
  }

  private generatePageGroupId(): string {
    return `page_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }

  addMatch(document: any, pageGroupId?: string, pageIndex?: number, parentMatchId?: string, pageLabel?: string, pageEndIndex?: number, pagePairId?: string) {
    const match = {
      nombre_op: '',
      nombre_layout: '',
      layout: '1x1',
      version: null,
      cantidad: 0,
      id_archivo: document.id_archivo,
      idArtePreproyecto: 0,
      id_sku: 0,
      material_id: 0,
      countedMaterialId: null,
      tintas: '',
      page_group_id: pageGroupId || this.generatePageGroupId(),
      page_index: pageIndex ?? null,
      page_label: pageLabel || null,
      page_end_index: pageEndIndex ?? pageIndex ?? null,
      page_pair_id: pagePairId || null,
      parent_match_id: parentMatchId || null,
      is_page_row: !parentMatchId,
      is_child_row: !!parentMatchId,
      bitValido: null,
      archivo_respuesta_report: null
    };

    document.matches.push(match);
  }

  addPageChild(document: any, parentMatch: any) {
    const parentPageId = parentMatch.page_group_id || parentMatch.id || this.generatePageGroupId();
    const newIndex = (document.matches.indexOf(parentMatch) + 1);

    const child = {
      nombre_op: '',
      nombre_layout: '',
      layout: '1x1',
      version: null,
      cantidad: 0,
      id_archivo: document.id_archivo,
      idArtePreproyecto: 0,
      id_sku: 0,
      material_id: 0,
      countedMaterialId: null,
      tintas: '',
      page_group_id: parentPageId,
      page_index: parentMatch.page_index ?? null,
      parent_match_id: parentMatch.page_index || null,
      is_page_row: false,
      is_child_row: true
    };

    document.matches.splice(newIndex, 0, child);
  }

  isValidStartingVersion(): boolean {
    return Number.isInteger(this.versionDesde) && (this.versionDesde as number) >= 0;
  }

  assignConsecutiveVersions(): void {
    if (!this.isValidStartingVersion() || !this.selectedDocument?.matches) {
      return;
    }

    const versionsByPage = new Map<string, number>();
    let nextVersion = this.versionDesde as number;

    this.selectedDocument.matches.forEach((match: any, index: number) => {
      if (match.is_child_row) {
        return;
      }

      const pageKey = this.getVersionPageKey(match, index);
      if (!versionsByPage.has(pageKey)) {
        versionsByPage.set(pageKey, nextVersion);
        nextVersion += 1;
      }
    });

    this.selectedDocument.matches.forEach((match: any, index: number) => {
      const pageKey = this.getVersionPageKey(match, index);
      const version = versionsByPage.get(pageKey);
      if (version !== undefined) {
        match.version = version;
      }
    });
  }

  assignSameVersionToAll(): void {
    if (!this.isValidStartingVersion() || !this.selectedDocument?.matches) {
      return;
    }

    this.selectedDocument.matches.forEach((match: any) => {
      match.version = this.versionDesde;
    });
  }

  private getVersionPageKey(match: any, index: number): string {
    if (match.page_group_id !== null && match.page_group_id !== undefined) {
      return `group_${match.page_group_id}`;
    }

    if (match.page_index !== null && match.page_index !== undefined) {
      return `page_${match.page_index}`;
    }

    return `row_${index}`;
  }

  onSkuSelected(match: any) {
    const selectedSku = this.selectedDocument?.skuOdoo?.find(
      (sku: any) => sku.product_id == match.id_sku
    );

    match.selectedSku = selectedSku;
    match.validando = false;
    match.tintas = selectedSku?.tintas || '';
  }

  hasProductWithEvenTintas(document: any = this.selectedDocument): boolean {
    return (document?.skuOdoo || []).some((sku: any) => {
      const valueAfterX = String(sku.tintas || '').match(/x\s*(\d+)/i);
      if (!valueAfterX) {
        return false;
      }

      const tintasValue = Number(valueAfterX[1]);
      return tintasValue !== 0 && tintasValue % 2 === 0;
    });
  }

  getPageLabel(match: any): string {
    if (match.is_child_row) {
      return '';
    }

    const startPage = Number(match.page_index);
    const endPage = Number(match.page_end_index || startPage);
    const groupedLabel = this.selectedDocument?.type_match === 2 &&
      !this.selectedDocument?.f_igual_v &&
      this.hasProductWithEvenTintas() &&
      endPage > startPage
        ? ` y Página ${endPage}`
        : '';
    const frontBackLabel = this.selectedDocument?.f_igual_v ? ' (f=v)' : '';

    return `Página ${startPage}${groupedLabel}${frontBackLabel}`;
  }

  confirmFigualvChange(checked: boolean): void {
    const document = this.selectedDocument;
    if (!document) {
      return;
    }

    const previousValue = !!document.f_igual_v;
    if (document.type_match !== 2 || !this.hasProductWithEvenTintas()) {
      document.f_igual_v = checked;
      return;
    }

    Swal.fire({
      icon: 'warning',
      title: checked ? 'Activar Frente = vuelta' : 'Desactivar Frente = vuelta',
      text: 'Se reorganizarán los renglones por página. ¿Deseas continuar?',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        document.f_igual_v = checked;
        document.matches = checked
          ? this.expandPairedPageMatches(document.matches || [], document)
          : this.groupPagePairs(document.matches || [], document);
      } else {
        document.f_igual_v = previousValue;
      }
    });
  }

  private normalizePageMatchRows(document: any): void {
    if (document.type_match !== 2 || !this.hasProductWithEvenTintas(document)) {
      return;
    }

    document.matches = document.f_igual_v
      ? this.expandPairedPageMatches(document.matches || [], document)
      : this.groupPagePairs(document.matches || [], document);
  }

  private expandPairedPageMatches(matches: any[], document: any = this.selectedDocument): any[] {
    const expanded: any[] = [];
    const parents = matches.filter(match => !match.is_child_row);
    const children = matches.filter(match => match.is_child_row);
    const pageCount = Number(document?.paginas) || parents.length;

    for (let page = 1; page <= pageCount; page++) {
      const source = parents.find(match => Number(match.page_index) === page) ||
        parents.find(match => Number(match.page_index) <= page && Number(match.page_end_index || match.page_index) >= page) ||
        parents.find(match => Number(match.page_index) === page - 1) ||
        parents[Math.min(page - 1, parents.length - 1)];
      if (!source) {
        continue;
      }

      const pageGroupId = this.generatePageGroupId();
      expanded.push({
        ...source,
        idArtePreproyecto: Number(source.page_index) === page ? source.idArtePreproyecto : 0,
        page_index: page,
        page_end_index: page,
        page_label: `Página ${page}`,
        page_group_id: pageGroupId,
        page_pair_id: null
      });

      children.filter(child => child.page_group_id === source.page_group_id ||
        Number(child.page_index) === Number(source.page_index)).forEach(child => {
        expanded.push({
          ...child,
          idArtePreproyecto: Number(child.page_index) === page ? child.idArtePreproyecto : 0,
          page_index: page,
          page_end_index: page,
          page_group_id: pageGroupId,
          page_pair_id: null,
          parent_match_id: page
        });
      });
    }

    return expanded;
  }

  private groupPagePairs(matches: any[], document: any = this.selectedDocument): any[] {
    const parents = matches.filter(match => !match.is_child_row)
      .sort((left, right) => Number(left.page_index) - Number(right.page_index));
    const children = matches.filter(match => match.is_child_row);
    const pageCount = Number(document?.paginas) || parents.length;
    const grouped: any[] = [];
    const rowCount = pageCount > 1 ? Math.ceil(pageCount / 2) : pageCount;

    for (let index = 0; index < rowCount; index++) {
      const firstPage = pageCount > 1 ? index * 2 + 1 : 1;
      const lastPage = pageCount > 1 ? firstPage + 1 : firstPage;
      const source = parents.find(match => Number(match.page_index) === firstPage) ||
        parents.find(match => Number(match.page_index) <= firstPage && Number(match.page_end_index || match.page_index) >= firstPage) ||
        parents[Math.min(index, parents.length - 1)];
      if (!source) {
        continue;
      }

      const pageGroupId = this.generatePageGroupId();
      grouped.push({
        ...source,
        idArtePreproyecto: Number(source.page_index) === firstPage ? source.idArtePreproyecto : 0,
        page_index: firstPage,
        page_end_index: lastPage,
        page_label: pageCount > 1 ? `Página ${firstPage} y Página ${lastPage}` : `Página ${firstPage}`,
        page_group_id: pageGroupId,
        page_pair_id: this.generatePageGroupId()
      });

      children.filter(child => child.page_group_id === source.page_group_id ||
        Number(child.page_index) === firstPage).forEach(child => {
        grouped.push({
          ...child,
          page_index: firstPage,
          page_end_index: lastPage,
          page_group_id: pageGroupId,
          page_pair_id: null
        });
      });
    }

    return grouped;
  }

  onNombreOpChange(materialId: number, match: any): void {
    const previousMaterialId = this.normalizeMaterialId(match.countedMaterialId);
    const nextMaterialId = this.normalizeMaterialId(materialId);

    if (previousMaterialId !== nextMaterialId) {
      match.countedMaterialId = nextMaterialId;
      match.material_id = materialId;
      this.updateMaterialSelectionCounts();
    }

    const selectedMaterial = this.materiales.find(
      (material: any) => material.id == materialId
    ) as any;

    match.cantidad = selectedMaterial?.cantidad || 0;
    match.nombre_layout = selectedMaterial?.nombre || '';
  }

  getMaterialSelectionCount(materialId: number | string, currentMatch: any): number {
    const key = String(materialId);
    const totalCount = this.materialSelectionCounts.get(key) || 0;
    const currentMatchMaterialId = this.normalizeMaterialId(
      currentMatch?.countedMaterialId ?? currentMatch?.material_id
    );
    const currentMatchUsesMaterial = currentMatchMaterialId === key;

    return Math.max(0, totalCount - (currentMatchUsesMaterial ? 1 : 0));
  }

  private normalizeMaterialId(materialId: any): string | null {
    return materialId === null || materialId === undefined || materialId === '' || materialId === 0 || materialId === '0'
      ? null
      : String(materialId);
  }

  private updateMaterialSelectionCounts(): void {
    this.materialSelectionCounts.clear();

    this.dataMatCamp.forEach((campMaterial: any) => {
      if (campMaterial.id_material === null || campMaterial.id_material === undefined || campMaterial.id_material === '') {
        return;
      }

      const materialKey = String(campMaterial.id_material);
      this.materialSelectionCounts.set(
        materialKey,
        (this.materialSelectionCounts.get(materialKey) || 0) + 1
      );
    });

    this.documents.forEach(document => {
      (document.matches || []).forEach((match: any) => {
        const materialKey = this.normalizeMaterialId(match.material_id);
        if (materialKey === null) {
          return;
        }

        this.materialSelectionCounts.set(
          materialKey,
          (this.materialSelectionCounts.get(materialKey) || 0) + 1
        );
      });
    });
  }

  isMaterialUnavailable(materialId: number | null | undefined): boolean {
    return !!materialId && !this.materiales.some(
      material => material.id == materialId
    );
  }

  validarSku(sku: any, match: any, selectedDocument: any) {
    if (!sku || match.validando) return;

    match.validando = true;

    const sendData = {
      ancho: sku.ancho,
      alto: sku.alto,
      archivo: selectedDocument.archivo,
      strategy_id: this.strategy.id,
      pagina: match.page_index,
      pagina_end: match.page_end_index
    };

    const idArchivo = Number(match.idArtePreproyecto) || 0;

    if (selectedDocument.pagesMedidasDif == 0 || (selectedDocument.pagesMedidasDif == 1 && selectedDocument.type_match == 2) ) {
      this.campaignService.uploadArtEnfocus(sendData).subscribe({
        next: (result: any) => {
          if (result && result.nameArte) {
            this.obtenerFilesFtp(result.nameArte, idArchivo).then((ftpResult: any) => {
              match.validando = false;
              match.bitValido = ftpResult?.bitValido;
              match.archivo_respuesta_report = ftpResult?.fileUrlReport;

              if (ftpResult?.noEncontrado === 4) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Atención',
                  text: 'No se pudo encontrar el archivo en el FTP, por favor intenta más tarde.'
                });
              }
            }).catch(() => {
              match.validando = false;
            });
          } else {
            match.validando = false;
          }
        },
        error: (err: any) => {
          match.validando = false;
          console.error('Error al subir arte a Enfocus:', err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: err?.error?.message || 'Ocurrió un error al procesar el archivo.'
          });
        }
      });
    } else {
      match.validando = false;
      match.bitValido = 0;
      match.archivo_respuesta_report = null;
    }
  }

  validarTodoMasivo(selectedDocument: any) {
    if (!selectedDocument || !selectedDocument.matches) return;

    const matchesAValidar = selectedDocument.matches.filter((match: any) => 
      match.id_sku != 0 && 
      match.id_sku != null && 
      !match.validando && 
      (match.bitValido == null || match.bitValido == 0)
    );

    if (matchesAValidar.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No hay nada que validar',
        text: 'Todos los renglones ya están validados o faltan productos por seleccionar.'
      });
      return;
    }

    matchesAValidar.forEach((match: any) => {
      this.validarSku(match.selectedSku, match, selectedDocument);
    });
  }

  private organizeMatches(matches: any[]): any[] {
    const parentMatches = matches.filter(match => !match.is_child_row);
    const childMatches = matches.filter(match => match.is_child_row);
    const associatedChildren = new Set<any>();

    const organizedMatches = parentMatches.flatMap(parentMatch => {
      const children = childMatches.filter(childMatch =>
        childMatch.page_index != null &&
        parentMatch.page_index != null &&
        String(childMatch.page_index) === String(parentMatch.page_index)
      );

      children.forEach(childMatch => associatedChildren.add(childMatch));
      return [parentMatch, ...children];
    });

    return [
      ...organizedMatches,
      ...childMatches.filter(childMatch => !associatedChildren.has(childMatch))
    ];
  }

  ensureInitialMatch(document: any) {
    if (!document) {
      return;
    }

    if (!Array.isArray(document.matches)) {
      document.matches = [];
    }

    if (document.type_match === 1 && document.matches.length === 0) {
      this.addMatch(document);
    }
  }

  removeMatch(index: number) {
    const materialId = this.selectedDocument.matches[index]?.countedMaterialId;
    if (materialId) {
      this.materialSelectionCounts.delete(String(materialId));
    }
    this.selectedDocument.matches.splice(index, 1);
  }

  removeAssociatedMatch(document: any, match: any) {
    if (!document || !Array.isArray(document.matches)) {
      return;
    }

    const index = document.matches.indexOf(match);
    if (index > -1) {
      document.matches.splice(index, 1);
    }
  }

  validarMatches(): void {
    if (!this.completed) {
      const faltantes: string[] = [];
      const validaPag: string[] = [];

      this.documents.forEach((document: any) => {
        (document.matches || []).forEach((match: any, index: number) => {
          const camposFaltantes: string[] = [];

          if (!match.material_id) {
            camposFaltantes.push('Nombre Op.');
          }
          if (!String(match.nombre_layout || '').trim()) {
            camposFaltantes.push('Nombre Layout');
          }
          if (!String(match.layout || '').trim()) {
            camposFaltantes.push('Layout');
          }
          if (!match.id_sku) {
            camposFaltantes.push('Producto');
          }

          if (camposFaltantes.length > 0) {
            faltantes.push(
              `<li><strong>${document.nombre_archivo}</strong> - renglón ${index + 1}: ${camposFaltantes.join(', ')}</li>`
            );
          }
        });

        if (this.hasProductWithEvenTintas() && document.paginas % 2 === 1) {
          validaPag.push(`<li><strong>${document.nombre_archivo}</strong></li>`);
        }
      });

      if (faltantes.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Faltan datos por capturar',
          html: `<p>Completa la siguiente información antes de continuar:</p><ul class="text-start">${faltantes.join('')}</ul>`,
          confirmButtonText: 'Ok'
        });
        return;
      }
      if (validaPag.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          html: `<p>Se detectó que este archivo tiene número de páginas impares y está configurado como frente y vuelta</p><ul class="text-start">${validaPag.join('')}</ul>`,
          confirmButtonText: 'Ok'
        });
        return;
      }
    }

    this.switchArtesPreproyecto(this.artes, this.dataPreproject, 1, this.matches);
  }

  duplicateMatch(match: any) {
    const duplicate = { ...match, countedMaterialId: null };
    this.selectedDocument.matches.push(duplicate);
    if (duplicate.material_id) {
      this.onNombreOpChange(duplicate.material_id, duplicate);
    }
  }

  selectDocument(doc: any) {
    this.selectedDocument = doc;
    this.ensureInitialMatch(this.selectedDocument);
  }

  structureMatches(type: number) {
    const document = this.documents.find(
      doc => doc.id_archivo === this.selectedDocument?.id_archivo
    ) as any;

    if (!document) {
      return;
    }

    document.type_match = type;
    this.selectedDocument = document;

    if (type == 1) {
      this.matches = [];
      document.matches = [];
      this.addMatch(document);
    } else {
      this.matches = [];
      document.matches = [];
      const hasEvenTintas = this.hasProductWithEvenTintas();
      const groupedPairs = hasEvenTintas && !document.f_igual_v;
      const pageCount = Number(document.paginas) || 0;
      const rowCount = groupedPairs && pageCount > 1 ? Math.ceil(pageCount / 2) : pageCount;

      for (let i = 0; i < rowCount; i++) {
        const pageGroupId = this.generatePageGroupId();
        const firstPage = groupedPairs && pageCount > 1 ? i * 2 + 1 : i + 1;
        const lastPage = groupedPairs ? Math.min(firstPage + 1, pageCount) : firstPage;
        const pageLabel = groupedPairs
          ? `Página ${firstPage} y Página ${lastPage}`
          : `Página ${firstPage}`;
        const pagePairId = groupedPairs ? this.generatePageGroupId() : undefined;

        this.addMatch(document, pageGroupId, firstPage, undefined, pageLabel, lastPage, pagePairId);
      }
    }
  }

  openDialogArte(element: any, pageNumber?: number) {
    let target = element;

    if (typeof element === 'string') {
      const cleanUrl = element.split('#')[0];
      if (pageNumber) {
        target = `${cleanUrl}#page=${pageNumber}&view=Fit`;
      } else {
        target = `${cleanUrl}#view=Fit`;
      }
    }

    const dialogRef = this.matDialog.open(SkuImageComponent, {
      width: '90vw',       
      maxWidth: '1800px',   
      height: '95vh',
      data : target
    });
  }

  openDialogHistorial(idSku: number, medidaX: number, medidaY: number, idFamily: number, family: string) {
    this.matDialog.open(DistributionArtFileComponent, {
      panelClass: ['dialogs-md'],
      data: {
        strategy : this.data.strategy,
        idSku: idSku,
        medida_x: medidaX,
        medida_y: medidaY,
        toggleEnfocus: 0,
        idFamily: idFamily,
        family: family
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload){
          this.loadData();
        }
      }
    );
  }

  confirmStructureChange(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const nextType = this.selectedDocument.type_match === 2 ? 1 : 2;

    Swal.fire({
      icon: 'warning',
      title: 'Cambiar de modo',
      text: 'Cambiar de modo regenera los renglones y se pierde lo capturado. ¿Continuar?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {
      if (result.isConfirmed) {
        this.structureMatches(nextType);
      }
    });
  }

  clearSearch2(): void {
    this.searchTerm = '';
    this.filteredMateriales = [...this.materiales]; 
  }

  filterAtt() {
    const term = String(this.searchTerm || '').trim().toLocaleLowerCase();

    this.filteredMateriales = this.materiales.filter((material: any) =>
      String(material.nombre || '').toLocaleLowerCase().includes(term)
    );
  }

  verLayout(archivo: any){
    const dialogRef = this.matDialog.open(LayoutViewComponent, {
      panelClass: ['dialogs-xxl'],
      data : archivo
    });
  }
}